"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEPRECATED_COLORS = exports.COLOR = void 0;
var _colors = require("../../helpers/colors");
const GREY = {
  LIGHT: '#DEDBDD',
  MEDIUM: '#8D9495',
  DARK: '#495456'
};
const PRIMARY = '#FFDF4E';
const SECONDARY = '#3E487D';
const ACCENT = {
  PRIMARY,
  PRIMARY_120: (0, _colors.shade)(PRIMARY, 120),
  PRIMARY_60: (0, _colors.shade)(PRIMARY, 60),
  PRIMARY_20: (0, _colors.shade)(PRIMARY, 20),
  PRIMARY_10: (0, _colors.shade)(PRIMARY, 10),
  SECONDARY,
  SECONDARY_120: (0, _colors.shade)(SECONDARY, 120),
  SECONDARY_60: (0, _colors.shade)(SECONDARY, 60),
  SECONDARY_20: (0, _colors.shade)(SECONDARY, 20),
  SECONDARY_10: (0, _colors.shade)(SECONDARY, 10),
  PINK: '#FC7E84',
  // deprecated
  LIGHT_PINK: '#FBF2ED' // deprecated
};

const ERROR = '#D00E01';
const SUCCESS = '#04724D';
const WARNING = '#FFBB4E';
const ACTIVE = '#4579FF';
const STATE = {
  ERROR,
  ERROR_120: (0, _colors.shade)(ERROR, 120),
  ERROR_60: (0, _colors.shade)(ERROR, 60),
  ERROR_20: (0, _colors.shade)(ERROR, 20),
  ERROR_10: (0, _colors.shade)(ERROR, 10),
  SUCCESS,
  SUCCESS_120: (0, _colors.shade)(SUCCESS, 120),
  SUCCESS_60: (0, _colors.shade)(SUCCESS, 60),
  SUCCESS_20: (0, _colors.shade)(SUCCESS, 20),
  SUCCESS_10: (0, _colors.shade)(SUCCESS, 10),
  WARNING,
  WARNING_120: (0, _colors.shade)(WARNING, 120),
  WARNING_60: (0, _colors.shade)(WARNING, 60),
  WARNING_20: (0, _colors.shade)(WARNING, 20),
  WARNING_10: (0, _colors.shade)(WARNING, 10),
  ACTIVE,
  ACTIVE_120: (0, _colors.shade)(ACTIVE, 120),
  ACTIVE_60: (0, _colors.shade)(ACTIVE, 60),
  ACTIVE_20: (0, _colors.shade)(ACTIVE, 20),
  ACTIVE_10: (0, _colors.shade)(ACTIVE, 10),
  HIGHLIGHT: (0, _colors.shade)(ACTIVE, 20)
};
const BACKGROUND = {
  FOG: '#F9F9F9',
  SMOKE: '#F3F3F3',
  CREAM: '#FBFAF0',
  // deprecated
  MINT: '#DBEAE2',
  // deprecated
  BEIGE: '#DFE0BD' // deprecated
};

const COLOR = exports.COLOR = {
  WHITE: '#FFFFFF',
  BLACK: '#000000',
  GREY,
  ACCENT,
  STATE,
  BACKGROUND
};

// todo: deprecate these colors in next major release
const DEPRECATED_COLORS = exports.DEPRECATED_COLORS = [COLOR.ACCENT.PINK, COLOR.ACCENT.LIGHT_PINK, COLOR.BACKGROUND.CREAM, COLOR.BACKGROUND.MINT, COLOR.BACKGROUND.BEIGE];